export default {
    id: null,
    status: 0
}
